<template>
	<div class="cjt-footer">
		<div class="footer-content">
			<div class="footer-nav">
				<div class="nav-group">
					<span class="nav-title">查询服务</span>
					<div class="nav-divider">|</div>
					<div class="nav-links">
						<router-link to="/qualification-query/company">查企业</router-link>
						<router-link to="/qualification-query/person">查人员</router-link>
						<router-link to="/qualification-query/project">查项目</router-link>
					</div>
				</div>

				<div class="nav-group">
					<span class="nav-title">资质诊断</span>
					<div class="nav-divider">|</div>
					<div class="nav-links">
						<router-link to="/qualification/maintenance">资质维护</router-link>
						<router-link to="/qualification/new">首次申请</router-link>
						<router-link to="/qualification/upgrade">升级</router-link>
						<router-link to="/qualification/additional">增项</router-link>
						<router-link to="/qualification/renewal">延续</router-link>
						<router-link to="/qualification/reEvaluate">重新核定</router-link>
					</div>
				</div>

				<div class="nav-group">
					<span class="nav-title">个人中心</span>
					<div class="nav-divider">|</div>
					<div class="nav-links">
						<router-link to="/user/profile">个人设置</router-link>
						<router-link to="/user/message">消息通知</router-link>
						<router-link to="/user/monitor/list">监控预警</router-link>
						<router-link to="/user/market/order">会员管理</router-link>
					</div>
				</div>
			</div>

			<!-- <div class="footer-qrcode">
				<div class="qrcode-item">
					<img src="@/assets/qrcode.png" alt="楚建通公众号" />
					<p>"楚建通"公众号</p>
					<p class="contact">电话：XXX-XXXXXX</p>
					<p class="contact">地址：XX省XX市XX区XXXXXXX</p>
				</div>
				<div class="qrcode-item">
					<img src="@/assets/qrcode.png" alt="楚建通小程序" />
					<p>"楚建通"微信小程序</p>
					<p class="contact">邮箱：XXXXXXX@XXX.COM</p>
				</div>
			</div> -->
		</div>

		<!-- 底部icp备案及版权 -->
		<div class="copyright">
			<p>
				©2025-现在
				<a class="icp-link" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">鄂ICP备16005966号</a>
				&ensp; 鄂B2-20250641 版权所有 武汉佳软信息技术有限公司
			</p>
			<a class="icp-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=42018502007998" rel="noreferrer" target="_blank">
				<img src="@/assets/icp.png" alt="" />
				&ensp; 鄂公网安备42018502007998号
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PageFooter',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.cjt-footer {
		background-color: #0066cc;
		padding: 30px 0;
		color: #fff;

		.footer-content {
			width: $main-page-width;
			margin: 0 auto;
			display: flex;
			justify-content: space-evenly;

			.footer-nav {
				display: flex;
				flex-direction: row;
				align-items: center;
				// gap: 15px;
				padding: 15px 0;

				.nav-group {
					display: flex;
					align-items: center;
					// width: 100%;

					& + .nav-group {
						margin-left: 30px;
					}

					.nav-title {
						font-size: 18px;
						font-weight: bold;
						white-space: nowrap;
						// padding: 0 15px;
					}

					.nav-divider {
						color: rgba(255, 255, 255, 0.5);
						margin: 0 10px;
					}

					.nav-links {
						display: flex;
						flex-wrap: wrap;
						gap: 20px;

						a {
							color: #ffffff;
							text-decoration: none;
							font-size: 16px;
							transition: opacity 0.2s;

							&:hover {
								opacity: 0.8;
							}
						}
					}
				}
			}

			.footer-links {
				display: flex;
				position: relative;
				// padding-right: 80px;

				// &::after {
				// 	content: '';
				// 	position: absolute;
				// 	right: 0;
				// 	top: 0;
				// 	height: 100%;
				// 	width: 1px;
				// 	background: #ffffff;
				// }

				.link-group {
					& + .link-group {
						margin-left: 80px;
					}

					h3 {
						color: #ffffff;
						font-size: 18px;
						margin-bottom: 15px;
						font-weight: bold;
					}

					.link-list {
						a {
							display: block;
							color: #ffffff;
							font-size: 16px;
							line-height: 36px;
							text-decoration: none;

							&:hover {
								color: #fff;
							}
						}
					}
				}
			}

			.footer-qrcode {
				display: flex;
				padding-left: 60px;

				.qrcode-item {
					& + .qrcode-item {
						margin-left: 30px;
					}

					text-align: center;

					img {
						width: 100px;
						height: 100px;
						margin-bottom: 8px;
						background: #fff;
						padding: 5px;
						border-radius: 4px;
					}

					p {
						font-size: 12px;
						color: rgba(255, 255, 255, 0.7);
						line-height: 1.5;

						&.contact {
							margin-top: 5px;
						}
					}
				}
			}
		}

		.copyright {
			height: 40px;
			background: none;
			p,
			.icp-link {
				color: #ffffff;
			}
		}
	}
</style>
